export default __webpack_public_path__ + "static/media/Words3.5608bb2a.png";